import { __read, __spreadArray } from "tslib";
var getLockKey = function (propertyName) { return "".concat(String(propertyName), "__locked"); };
var getResultKey = function (propertyName) { return "".concat(String(propertyName), "__result"); };
/**
 * method decorator 给 method 加锁，执行完一次后加锁
 */
function lockOnce() {
    return function (target, propertyKey, descriptor) {
        var originalValue = descriptor.value;
        var lockKey = getLockKey(propertyKey);
        var resultKey = getResultKey(propertyKey);
        descriptor.value = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (!this[lockKey]) {
                this[resultKey] = originalValue.call.apply(originalValue, __spreadArray([this], __read(args), false));
                this[lockKey] = true;
            }
            return this[resultKey];
        };
    };
}
/**
 * method decorator，解除 lock 的限制使其可以继续执行
 * @param lockedMethodName 需要释放的key，指的是class中lock的方法名
 */
function releaseLock(lockedMethodName) {
    return function (target, propertyKey, descriptor) {
        var originalValue = descriptor.value;
        var lockKey = getLockKey(lockedMethodName);
        var resultKey = getResultKey(lockedMethodName);
        descriptor.value = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this[lockKey]) {
                this[lockKey] = false;
                this[resultKey] = undefined;
            }
            return originalValue.call.apply(originalValue, __spreadArray([this], __read(args), false));
        };
    };
}
export { lockOnce, releaseLock, };
